import './get-appointment.shop.js';



// WEBPACK FOOTER //
// ./components/shop/util/index.js